import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { OpenSourceComponent } from './open-source.component';


const routes: Routes = [
  {
    path: 'open-source',
    component: OpenSourceComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class OpenSourceRoutingModule {}
